module.exports = "/next-static/_next/static/images/hero_image_small-f6bc82a24a655620fbc66c29886f753a.png";